export default "/images/ico-h-user.svg?161435ca93315052a5f47304e38f2126";